export default __webpack_public_path__ + "static/media/36I-102629_-15541_0.dd21b5ff.jpg";